const ConfirmationModal = ({ onConfirm, onCancel, message, loading }) => {
    const modalStyle = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 1000,
    };

    const modalContentStyle = {
        backgroundColor: '#fff',
        padding: '20px',
        borderRadius: '8px',
        width: '400px',
        textAlign: 'center',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    };

    const buttonStyle = {
        padding: '10px 20px',
        borderRadius: '4px',
        border: 'none',
        cursor: 'pointer',
        margin: '0 10px',
    };

    return (
        <div style={modalStyle}>
            <div style={modalContentStyle}>
                <h3>Confirm Deletion</h3>
                <p>{message}</p>
                <div>
                    <button
                        onClick={onConfirm}
                        disabled={loading}
                        style={{ ...buttonStyle, backgroundColor: '#dc3545', color: 'white' }}>
                        {loading ? 'Deleting' : 'Confirm Delete'}
                    </button>
                    <button
                        onClick={onCancel}
                        style={{ ...buttonStyle, backgroundColor: '#6c757d', color: 'white' }}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;